var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-select',{attrs:{"value":_vm.value,"addNewEnable":true,"label":"Единица изм.","options":_vm.options_units[_vm.unit_param]},on:{"input":function (e) { return _vm.$emit('input', e); },"addNew":_vm.addNew}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e72f1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard/components/unitSelect.vue
// module id = null
// module chunks = 